// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1690312082
// </auto-generated>
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { SmartListCriteria, SmartListResult } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';
import { Observable, Subject } from 'rxjs';

import { FileResponse } from 'carehub-shared/fileResponse';
import { map } from 'rxjs/operators';
import { UploadObject } from '../shared/models/uploadobject';
import { Address } from './models/client/address';
import { BulkEligibilityRequest } from './models/client/bulkeligibilityrequest';
import { ChannelPartner } from './models/client/channelpartner';
import { Client } from './models/client/client';
import { ClientName } from './models/client/clientname';
import { ClientProcedureCategoryIncentive } from './models/client/clientprocedurecategoryincentive';
import { ClientSummary } from './models/client/clientsummary';
import { Contact } from './models/client/contact';
import { Document } from './models/client/document';
import { Netsuite } from './models/client/netsuite';
import { Note } from './models/client/note';
import { Plan } from './models/client/plan';
import { PlanCoverage } from './models/client/plancoverage';
import { PlanNumber } from './models/client/plannumber';
import { PlanSummary } from './models/client/plansummary';
import { ThirdPartyOrg } from './models/client/thirdpartyorg';
import { BlobResult } from './models/common/blobresult';
import { ProcedureItem } from './models/common/procedureitem';
import { ProcedureItemCategory } from './models/common/procedureitemcategory';
import { Member } from './models/member/member';
import { MemberSearch } from './models/member/membersearch';
import { BulkEligibilityDetails } from './models/nonentity/bulkeligibilitydetails';
import { BulkRequestStatus } from './models/nonentity/bulkrequeststatus';
import { ClientPlanDesign } from './models/nonentity/clientplandesign';
import { ContractSummary } from './models/nonentity/contractsummary';
import { PrepaidReasonSummary } from './models/nonentity/prepaidreasonsummary';
import { ProcedureCategory } from './models/nonentity/procedurecategory';
import { ProcedureSummary } from './models/nonentity/proceduresummary';
import { TravelMileageReimbursement } from './models/nonentity/travelmileagereimbursement';
import { Vendor } from './models/vendor/vendor';

export interface findMembers_Filter {
  name: string;
}

export interface getProcedureItems_Filter {
  categoryId: number;
}

export interface getExcludedProceduresByClientId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getExcludedPrepaidReasonsByClientId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getContractsByClientId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getVendorsByClientId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getClientsByVendorId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getThirdPartyOrg_Filter {
  thirdPartyOrgNameFilter: string;
}

export interface getAllClientsSummaries_Filter {
  name: string;
  clientTypeId: number;
  statusId: number;
  goLiveDate: string;
  contractEffectiveDate: string;
  contractTerminationDate: string;
  hubAllocation: string;
  clientCode: string;
  opsClientId: string;
}

export interface getClientsByName_Filter {
  name: string;
  includeOnlyAddMemberEligibility: boolean;
}

export interface getClientThirdPartyOrgsByName_Filter {
  name: string;
  clientId: string;
}

export interface getClientContactsByName_Filter {
  name: string;
  clientId: string;
  contactTypeId: number;
}

export interface getPlansByName_Filter {
  name: string;
  clientId: string;
}

export interface getClientById_Filter {
  includeChildren: boolean;
}

export interface getClientByIdWithCaching_Filter {
  includeChildren: boolean;
}

export interface getMemberByClientId_Filter {
  clientId: string;
}

export interface GetChannelPartnersById_Filter {
  channelPartnerId: string;
}

export interface exportClientsListCsv_Filter {
  name: string;
  clientTypeId: number;
  statusId: number;
  goLiveDate: string;
  contractEffectiveDate: string;
  contractTerminationDate: string;
  hubAllocation: string;
}

export interface getPlanSummaries_Filter {
  name: string;
  planTypeId: number;
  reviewStatusId: number;
  planNumber: number;
  startDate: string;
  endDate: string;
  removeDinoPlans: boolean;
  planYear: number;
  excludePlanNumber: number;
}

export interface getBulkEligibilityRequest_Filter {
  requestName: string;
  requestedBy: string;
}
@Injectable({
  providedIn: 'root',
})
export class ClientsApiService {
  constructor(protected http: HttpClient) {}

  getMembers(
    clientGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Member>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/members`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Member>>(url);
  }

  findMembers(
    clientGuid: string,
    queryParams?: Partial<findMembers_Filter>
  ): Observable<MemberSearch[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/members/search`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberSearch[]>(url, { params: params });
  }

  getAddresses(
    clientGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Address>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/addresses`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Address>>(url);
  }

  getProcedureCategories(memberId: string): Observable<ProcedureCategory[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${memberId}/procedureCategories`;
    return this.http.get<ProcedureCategory[]>(url);
  }

  getNotes(
    clientGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Note>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/notes`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Note>>(url);
  }

  getTravelMileageReimbursements(
    memberId: string
  ): Observable<TravelMileageReimbursement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${memberId}/TravelMileageReimbursements`;
    return this.http.get<TravelMileageReimbursement>(url);
  }

  getProcedureItemCategories(
    clientGuid: string
  ): Observable<ProcedureItemCategory[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/procedureItemCategories`;
    return this.http.get<ProcedureItemCategory[]>(url);
  }

  getClientProcedureCategoryIncentives(
    clientGuid: string
  ): Observable<ClientProcedureCategoryIncentive[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/clientProcedureCategoryIncentives`;
    return this.http.get<ClientProcedureCategoryIncentive[]>(url);
  }

  getProcedureItems(
    clientGuid: string,
    queryParams?: Partial<getProcedureItems_Filter>
  ): Observable<ProcedureItem[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/procedureItems`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<ProcedureItem[]>(url, { params: params });
  }

  getExcludedProceduresByClientId(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getExcludedProceduresByClientId_Filter>
  ): Observable<SmartListResult<ProcedureSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/excludedprocedures`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProcedureSummary>>(url, {
      params: params,
    });
  }

  updateExcludedProceduresForClientId(
    clientGuid: string,
    ids: number[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/excludedprocedures`;
    return this.http.put<any>(url, ids);
  }

  getExcludedPrepaidReasonsByClientId(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getExcludedPrepaidReasonsByClientId_Filter>
  ): Observable<SmartListResult<PrepaidReasonSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/prepaidexcludedreasons`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<PrepaidReasonSummary>>(url, {
      params: params,
    });
  }

  updateExcludedPrepaidReasonsForClientId(
    clientGuid: string,
    ids: number[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/prepaidexcludedreasons`;
    return this.http.put<any>(url, ids);
  }

  getContractsByClientId(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getContractsByClientId_Filter>
  ): Observable<SmartListResult<ContractSummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/contracts`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ContractSummary>>(url, {
      params: params,
    });
  }

  updateContractsForClientId(
    clientGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/contracts`;
    return this.http.put<any>(url, ids);
  }

  getContactsByClientId(clientGuid: string): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/contacts`;
    return this.http.get<Contact[]>(url);
  }

  updateContactsForClientId(
    clientGuid: string,
    contacts: Contact[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/contacts`;
    return this.http.put<any>(url, contacts);
  }

  getVendorsByClientId(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getVendorsByClientId_Filter>
  ): Observable<SmartListResult<Vendor>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/vendors`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Vendor>>(url, {
      params: params,
    });
  }

  updateVendorsForClientId(clientGuid: string, ids: string[]): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/vendors`;
    return this.http.put<any>(url, ids);
  }

  getClientsByVendorId(
    vendorGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getClientsByVendorId_Filter>
  ): Observable<SmartListResult<Client>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${vendorGuid}/clients`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Client>>(url, {
      params: params,
    });
  }

  updateClientsForVendorId(vendorGuid: string, ids: string[]): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${vendorGuid}/clients`;
    return this.http.put<any>(url, ids);
  }

  addClientContacts(
    clientGuid: string,
    contacts: Contact[]
  ): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/contacts/add`;
    return this.http.put<Contact[]>(url, contacts);
  }

  addThirdPartyOrg(
    clientGuid: string,
    thirdPartyOrg: ThirdPartyOrg
  ): Observable<ThirdPartyOrg> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/third-party-orgs/add`;
    return this.http.put<ThirdPartyOrg>(url, thirdPartyOrg);
  }

  getThirdPartyOrg(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getThirdPartyOrg_Filter>
  ): Observable<SmartListResult<ThirdPartyOrg>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/thirdpartyorg`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ThirdPartyOrg>>(url, {
      params: params,
    });
  }

  updateThirdPartyOrg(
    clientGuid: string,
    thirdPartyOrgDtos: ThirdPartyOrg[]
  ): Observable<ThirdPartyOrg[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/thirdPartyOrgs`;
    return this.http.post<ThirdPartyOrg[]>(url, thirdPartyOrgDtos);
  }

  getDocumentsByClientId(clientGuid: string): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/documents`;
    return this.http.get<Document[]>(url);
  }

  addClientDocuments(
    clientGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getClientNames(): Observable<ClientName[]> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/names`;
    return this.http.get<ClientName[]>(url);
  }

  getPlanNumbers(): Observable<PlanNumber[]> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/plans`;
    return this.http.get<PlanNumber[]>(url);
  }
  getAllClients(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Client>> {
    let url = environment.chiliSauceApiRoot + `/api/Clients`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Client>>(url);
  }

  addClient(newClient: Client): Observable<Client> {
    const url = environment.chiliSauceApiRoot + `/api/Clients`;
    return this.http.post<Client>(url, newClient);
  }

  getAllClientsSummaries(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getAllClientsSummaries_Filter>
  ): Observable<SmartListResult<ClientSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Clients/summaries`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ClientSummary>>(url, {
      params: params,
    });
  }

  getClientsByName(
    queryParams?: Partial<getClientsByName_Filter>
  ): Observable<Client[]> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/by-name`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Client[]>(url, { params: params });
  }

  getAllVendors(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Vendor>> {
    let url = environment.chiliSauceApiRoot + `/api/Clients/vendors`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Vendor>>(url);
  }

  getClientThirdPartyOrgsByName(
    clientGuid: string,
    queryParams?: Partial<getClientThirdPartyOrgsByName_Filter>
  ): Observable<ThirdPartyOrg[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/third-party-org/by-name`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<ThirdPartyOrg[]>(url, { params: params });
  }

  getClientContactsByName(
    clientGuid: string,
    queryParams?: Partial<getClientContactsByName_Filter>
  ): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/contacts/by-name`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Contact[]>(url, { params: params });
  }

  getPlansByName(
    clientGuid: string,
    queryParams?: Partial<getPlansByName_Filter>
  ): Observable<Plan[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/plans/by-name`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Plan[]>(url, { params: params });
  }

  getAllPlans(clientGuid: string): Observable<Plan[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/plans/get-all`;
    return this.http.get<Plan[]>(url);
  }

  getPlans(
    clientGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Plan>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/getplans`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Plan>>(url);
  }

  getPlanCoveragesByPlanId(planGuid: string): Observable<PlanCoverage[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${planGuid}/plan-coverages/by-id`;
    return this.http.get<PlanCoverage[]>(url);
  }

  getClientById(
    clientGuid: string,
    queryParams?: Partial<getClientById_Filter>
  ): Observable<Client> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Client>(url, { params: params });
  }

  updateClient(client: Client, clientGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}`;
    return this.http.put<any>(url, client);
  }

  deleteClient(clientGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}`;
    return this.http.delete(url);
  }

  deletePlan(clientGuid: string, planGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/plans/${planGuid}`;
    return this.http.delete(url);
  }
  getClientByIdWithCaching(
    clientGuid: string,
    queryParams?: Partial<getClientByIdWithCaching_Filter>
  ): Observable<Client> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/cached`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Client>(url, { params: params });
  }

  addClientPlanDesign(
    newClientPlanDesign: ClientPlanDesign,
    clientGuid: string
  ): Observable<ClientPlanDesign> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/plans/add`;
    return this.http.post<ClientPlanDesign>(url, newClientPlanDesign);
  }

  getClientPlanDesign(
    clientGuid: string,
    planGuid: string
  ): Observable<ClientPlanDesign> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/plans/${planGuid}`;
    return this.http.get<ClientPlanDesign>(url);
  }

  getAllOpClientIds(): Observable<string[]> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/opsClientIds`;
    return this.http.get<string[]>(url);
  }

  getMemberByClientId(
    clientId: string,
    queryParams?: Partial<getMemberByClientId_Filter>
  ): Observable<Member> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientId}/memberLoadDate`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Member>(url, { params: params });
  }

  getAllChannelPartners(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<ChannelPartner>> {
    let url = environment.chiliSauceApiRoot + `/api/Clients/channelPartners`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<ChannelPartner>>(url);
  }

  GetChannelPartnersById(
    queryParams?: Partial<GetChannelPartnersById_Filter>
  ): Observable<ChannelPartner> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/channelPartnersName`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<ChannelPartner>(url, { params: params });
  }

  //! the buccaneer tool does not handle smartlist criteria with a file result,
  //!  and will not include the criteria parameter. Until the tool is updated to
  //!  support this use case, the below change should not be retained on code-gen
  exportClientsListCsv(
    criteria?: SmartListCriteria,
    queryParams?: Partial<exportClientsListCsv_Filter>
  ): Observable<FileResponse> {
    let url = environment.chiliSauceApiRoot + `/api/Clients/export-clients-csv`;
    const params = Utils.getHttpParams(queryParams);
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http
      .get(url, { responseType: 'blob', observe: 'response', params: params })
      .pipe(map(Utils.asFileResult));
  }

  updateClientPlanDesign(
    clientPlanDesign: ClientPlanDesign,
    clientGuid: string
  ): Observable<ClientPlanDesign> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/${clientGuid}/plans/update`;
    return this.http.post<ClientPlanDesign>(url, clientPlanDesign);
  }
  getPlanSummaries(
    clientGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getPlanSummaries_Filter>
  ): Observable<SmartListResult<PlanSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/plan/planSummaries`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<PlanSummary>>(url, {
      params: params,
    });
  }

  getPartnerById(vendorGuid: string): Observable<Vendor> {
    const url =
      environment.chiliSauceApiRoot + `/api/Clients/partners/${vendorGuid}`;
    return this.http.get<Vendor>(url);
  }

  addPartner(newPartner: Vendor): Observable<Vendor> {
    const url = environment.chiliSauceApiRoot + `/api/Clients/partners/add`;
    return this.http.put<Vendor>(url, newPartner);
  }

  updatePartner(partner: Vendor, vendorGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/partners/${vendorGuid}/update`;
    return this.http.put<any>(url, partner);
  }

  addClientNetsuiteDetails(
    netsuite: Netsuite,
    clientGuid: string
  ): Observable<Netsuite> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/UpdateClientNetsuiteDetails`;
    return this.http.put<Netsuite>(url, netsuite);
  }

  getClientNetsuiteDetailsById(clientGuid: string): Observable<Netsuite> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${clientGuid}/GetClientNetSuiteDetailsById`;
    return this.http.get<Netsuite>(url);
  }

  getBulkEligibilityRequests(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getBulkEligibilityRequest_Filter>
  ): Observable<SmartListResult<BulkEligibilityRequest>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Clients/getBulkEligibilityRequests`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<BulkEligibilityRequest>>(url, {
      params: params,
    });
  }

  updateBulkEligibilityRequest(
    request: BulkEligibilityDetails
  ): Observable<BulkEligibilityRequest> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/updateBulkEligibilityRequest`;
    return this.http.post<BulkEligibilityRequest>(url, request);
  }

  getBulkEligibilityRequestStatus(
    bulkEligibilityRequestId: string
  ): Observable<BulkRequestStatus> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Clients/${bulkEligibilityRequestId}/getBulkEligibilityRequestStatus`;
    return this.http.get<BulkRequestStatus>(url);
  }

  exportAccumulatorListCsv(requestGuid: string): Observable<FileResponse> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Clients/export-accumulator-csv/${requestGuid}`;
    return this.http
      .get(url, { responseType: 'blob', observe: 'response' })
      .pipe(map(Utils.asFileResult));
  }
}
